import { MutationOptions, useIsMutating, useMutation } from "@tanstack/react-query";
import {
  AuditBoookingPlaceholderPayload,
  createAuditBookingPlaceholder,
  CreateAuditBookingPlaceholderResponse
} from "PFCore/services/audit_bookings_approval";

import { auditBookingsApprovalsKeys } from "./query_keys";

export const useCreateAuditBookingPlaceholder = (
  options?: MutationOptions<
    CreateAuditBookingPlaceholderResponse,
    Error,
    AuditBoookingPlaceholderPayload,
    unknown
  >
) => {
  const mutationKey = auditBookingsApprovalsKeys.create();

  const createMutation = useMutation<
    CreateAuditBookingPlaceholderResponse,
    Error,
    AuditBoookingPlaceholderPayload
  >({
    mutationKey,
    mutationFn: async (payload: AuditBoookingPlaceholderPayload) => createAuditBookingPlaceholder(payload),
    ...options
  });

  const isCreating = useIsMutating({
    mutationKey
  });

  return {
    mutation: createMutation,
    create: createMutation.mutateAsync,
    isCreating
  };
};
